import { type FC } from 'react'
import styles from './styles.module.css'

/**
 * Used for loading animation on specific Enrollment pages to stagger content
 * @returns FC
 */
export const LoadingAnimation: FC = () => {
  return <div className={styles.loadingAnimation} />
}
